/**
 * BD-8595: real backend feature flags that reshape the onboarding tutorial.
 */
export interface TutorialFeatureFlags {
  zebraBarcodeEnabled: boolean
  collectTMInitialsEnabled: boolean
  collectCodeEnabled: boolean
}

/**
 * Numbered step count (excludes the unnumbered intro).
 * Zebra scan block replaces the late Order Details handoff; collection-code
 * tutorial step is skipped while Zebra is on so Zebra+TMI stays at 14.
 */
export function getTutorialTotalSteps(flags: TutorialFeatureFlags): number {
  if (flags.zebraBarcodeEnabled) {
    // 1–5 dashboard, 6–11 scan/details modal, 12–13 acknowledge/deliver, (+14 initials)
    return flags.collectTMInitialsEnabled ? 14 : 13
  }

  // Classic: 1–7 dashboard, 8 order details, optional collection code, optional initials
  let total = 8
  if (flags.collectCodeEnabled) {
    total += 1
  }
  if (flags.collectTMInitialsEnabled) {
    total += 1
  }
  return total
}
